import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiPaths } from "../../../../service/apiPaths";
import ApiService from "../../../../service/ApiService";
import { IAddUser, IUser } from "../../User.props";
import { SubmitHandler } from "react-hook-form";
import toast from "react-hot-toast";

const useAddUser = () => {
  const [formData, setFormData] = useState<IAddUser>({
    userName: "",
    userCode: "",
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [user, setUser] = useState<IUser | null>(null);

  const navigate = useNavigate();

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { id, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleSubmit: SubmitHandler<IAddUser> = async () => {
    try {
      const response = await ApiService({
        method: "POST",
        endpoint: `${apiPaths.createuser}`,
        data: {
          userName: formData.userName,
          userCode: formData.userCode,
        },
      });

      if (response !== "undefined") {
        toast.success("User added successfully", {
          duration: 10000, // Set the duration in milliseconds
        });
        navigate("/user"); // Redirect after successful update
      }
    } catch (error) {
      toast.error("Error updating status", {
        duration: 10000, // Set the duration in milliseconds
      });
      console.error("Error updating user:", error);
    }
  };

  const handleCancel = () => {
    navigate("/user");
  };

  return {
    loading,
    formData,
    user,
    handleChange,
    handleSubmit,
    handleCancel,
  };
};

export default useAddUser;
